var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('PaymentComponent',{attrs:{"user":_vm.user,"show_footer":false},on:{"refreshUser":_vm.refreshUser}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }